import React, { useContext } from "react";
import { RicosContext } from "./../../../ricos-context/index.js";
import { ModalDesktop } from "./modal-desktop.js";
import { ModalMobile } from "./modal-mobile.js";
const LinkModal = (props) => {
  const { isMobile } = useContext(RicosContext);
  return isMobile ? /* @__PURE__ */ React.createElement(ModalMobile, { ...props }) : /* @__PURE__ */ React.createElement(ModalDesktop, { ...props });
};
export {
  LinkModal
};
//# sourceMappingURL=link-modal.js.map
